import React from 'react';
import { FormattedMessage } from 'react-intl';
import EndorsingCharityLogo from './EndorsingCharityLogo';
import styles from './CharityEndorsed.scss';
import { CharityState } from 'src/redux/modules/charity/reducer';
import { LessThanMedium, Medium } from '@justgiving/responsive';
interface Props {
  charity: CharityState;
  isEndorsementAccepted: boolean;
  onChange: (event: any) => void;
}

const CreateCommittedPage: React.StatelessComponent<Props> = ({
  charity,
  isEndorsementAccepted,
  onChange,
}) => {
  return (
    <div>
      <fieldset
        className="jg-form-group jg-space-mtmd jg-space-mblg"
        key={`charity-endorsed`}
      >
        <input
          type="checkbox"
          id={`checkbox-charity-endorsed`}
          name={`checkbox-charity-endorsed`}
          onChange={onChange}
          className="jg-checkbox"
          defaultChecked
        />
        <label htmlFor={`checkbox-charity-endorsed`}>
          <p className="jg-text--regular">
            <FormattedMessage
              id="CreateCommittedPage.iWantToBeEndorsed"
              defaultMessage="I'd like my page to be associated with {charityName}, and will make a contribution to the charity "
              values={{
                charityName: charity!.name,
              }}
            />
          </p>
          <div
            className={`${styles['charity-info']} jg-display-flex ${
              isEndorsementAccepted ? '' : styles.opacity
            }`}
          >
            <LessThanMedium>
              <EndorsingCharityLogo
                displayTick={true}
                charityLogo={charity!.logo}
                className="jg-space-mrms@md jg-space-mbsm jg-space-mbn@md"
                smallIcon={true}
              />
            </LessThanMedium>
            <Medium>
              <EndorsingCharityLogo
                displayTick={true}
                charityLogo={charity!.logo}
                className="jg-space-mrms@md jg-space-mbsm jg-space-mbn@md"
              />
            </Medium>
            <div className={`jg-text--light jg-text`}>
              <FormattedMessage
                id="CharityEndorsedPage.yourPageWillBeAssociated"
                defaultMessage="Your page will be associated with {charityName}. Their logo will appear on your page, and you can make your contribution to them at any time whilst you’re crowdfunding to support the great work they do."
                values={{ charityName: charity!.name }}
              />
            </div>
          </div>
        </label>
      </fieldset>
    </div>
  );
};

export default CreateCommittedPage;



// WEBPACK FOOTER //
// ./src/components/CharityEndorsed/CreateCommittedPage.tsx